import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import Modal from 'react-modal';
import Sidebar from '../componenteExtra/SidebarLider';
import '../App.css';
import { GrupoContext } from '../GrupoContext';
import { Toaster, toast } from 'react-hot-toast';
import SessionManager from '../componenteExtra/SessionManager';

Modal.setAppElement('#root');

const PausedActivitiesLider = () => {
    const { grupo, setGrupo } = useContext(GrupoContext);
    const [activities, setActivities] = useState([]);
    const [selectedActivity, setSelectedActivity] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isStaffModalOpen, setIsStaffModalOpen] = useState(false); // Estado para el modal de staff
    const [staffList, setStaffList] = useState([]);

    const token = localStorage.getItem("access_token");

    useEffect(() => {
        const savedGrupo = localStorage.getItem('grupo');
        if (savedGrupo) {
            setGrupo(savedGrupo);
        }

        if (grupo) {
            fetchPausedActivities();
            fetchStaffList();
        }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grupo]);

    const fetchPausedActivities = () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/get_paused_activities_lider/${grupo}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
            .then(response => {
                setActivities(response.data);
            })
            .catch(error => console.error('Error fetching paused activities: ', error));
    };

    const fetchStaffList = () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/buscar_staff/${grupo}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
            .then(response => {
                setStaffList(response.data);
            })
            .catch(error => console.error('Error fetching staff data: ', error));
    };

    const handleReview = (activity) => {
        setSelectedActivity(activity);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedActivity(null);
    };

    const handleReassign = () => {
        setIsStaffModalOpen(true); // Abre el modal de staff
    };

    const handleCloseStaffModal = () => {
        setIsStaffModalOpen(false); // Cierra el modal de staff
    };

    const handleAssignStaff = () => {
        const staffAsignado = selectedActivity.staff_asignado;
        
        if (!staffAsignado || staffAsignado.trim() === '') {
            toast.error('Por favor seleccione un staff antes de continuar.');
            return;
        }

        const toastId = toast.loading('Asignando nuevo staff...');

        // Llamada a la API para reasignar la actividad con el nuevo staff
        axios.put(`${process.env.REACT_APP_BACKEND_URL}/reassign_activity/${selectedActivity.id}?nombre_staff_reasignado=${staffAsignado}`, null, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
            .then(response => {
                toast.dismiss(toastId);
                toast.success('Staff reasignado correctamente');
                handleCloseStaffModal(); // Cierra el modal de staff
                handleCloseModal(); // Cierra el modal principal
                setTimeout(() => {
                    window.location.reload(); // Refresca la página después de 1500 ms
                }, 1500);
            })
            .catch(error => {
                toast.dismiss(toastId);
                toast.error('Error al reasignar staff');
                console.error('Error reassigning staff:', error);
            });
    };

    const handleStaffChange = (e) => {
        setSelectedActivity({ ...selectedActivity, staff_asignado: e.target.value });
    };

    const handleReturn = () => {
        const toastId = toast.loading('Devolviendo actividad...');
        axios.put(`${process.env.REACT_APP_BACKEND_URL}/return_activity/${selectedActivity.id}`, null, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
            .then(response => {
                toast.dismiss(toastId);
                toast.success('Actividad devuelta y cerrada correctamente');
                handleCloseModal();
                setTimeout(() => {
                    window.location.reload(); // Refresca la página después de 1500 ms
                }, 1500);
            })
            .catch(error => {
                toast.dismiss(toastId);
                toast.error('Error al devolver actividad');
                console.error('Error returning activity:', error);
            });
    };

    const totalActividades = activities.length;

    return (
        <div className="app">
            <SessionManager />
            <Sidebar />
            <div className="main-content">
                <div className="main-panel">
                    <h1>Actividades pausadas - Grupo {grupo}</h1>
                    <h2>Total Actividades: {totalActividades}</h2>
                    <div className="activities-table-container">
                        <table className="activities-table">
                            <thead>
                                <tr>
                                    <th>Código de proyecto</th>
                                    <th>Razón social</th>
                                    <th>Filial</th>
                                    <th>Solicitante</th>
                                    <th>Tipo de trabajo</th>
                                    <th>Regulación</th>
                                    <th>Rubro GET</th>
                                    <th>Nombre actividad GET</th>
                                    <th>Fecha de entrega de información</th>
                                    <th>Fecha inicio</th>
                                    <th>Fecha término</th>
                                    <th>Staff</th>
                                    <th>Pausa</th>
                                    <th>Definición pausa</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {activities.map((activity, index) => (
                                    <tr key={index}>
                                        <td>{activity.codigo_proyecto}</td>
                                        <td>{activity.razon_social}</td>
                                        <td>{activity.filial}</td>
                                        <td>{activity.nombre_solicitante}</td>
                                        <td>{activity.tipo_solicitud}</td>
                                        <td>{activity.tipo_regulacion}</td>
                                        <td>{activity.rubro_get}</td>
                                        <td>{activity.nombre_actividad_get}</td>
                                        <td>{activity.fecha_entrega_informacion}</td>
                                        <td>{activity.fecha_de_inicio}</td>
                                        <td>{activity.fecha_de_termino}</td>
                                        <td>{activity.staff_asignado}</td>
                                        <td>{activity.pausa}</td>
                                        <td>{activity.definicion_pausa}</td>
                                        <td>
                                            <button className="action-button" onClick={() => handleReview(activity)}>Revisar</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {selectedActivity && (
                <Modal isOpen={isModalOpen} onRequestClose={handleCloseModal}>
                    <h1>Revisar actividad pausada</h1>
                    <h2><strong>Staff: </strong> {selectedActivity.staff_asignado}</h2>
                    <p><strong>Código de proyecto:</strong> {selectedActivity.codigo_proyecto}</p>
                    <p><strong>Razón social:</strong> {selectedActivity.razon_social}</p>
                    <p><strong>Filial:</strong> {selectedActivity.filial}</p>
                    <p><strong>Rubro GET:</strong> {selectedActivity.rubro_get}</p>
                    <p><strong>Nombre actividad GET:</strong> {selectedActivity.nombre_actividad_get}</p>
                    <p><strong>Jefe de grupo:</strong> {selectedActivity.jefe_grupo}</p>
                    <p><strong>Subrogante:</strong> {selectedActivity.subrogante}</p>
                    <p><strong>Fecha de inicio:</strong> {selectedActivity.fecha_de_inicio}</p>
                    <p><strong>Fecha de término:</strong> {selectedActivity.fecha_de_termino}</p>
                    <p><strong>Horas GET:</strong> {selectedActivity.horas_get}</p>
                    <p><strong>Horas estándar:</strong> {selectedActivity.horas_estandar}</p>
                    <p><strong>Estado pausa:</strong> {selectedActivity.estado_pausa}</p>
                    <p><strong>Enlace comentario:</strong> {selectedActivity.enlace_comentario}</p>
                    <p><strong>Tipo pausa:</strong> {selectedActivity.pausa}</p>
                    <p><strong>Definición pausa:</strong> {selectedActivity.definicion_pausa}</p>

                    {[4, 5, 6, 7, 9].includes(selectedActivity.estado_pausa) ? (
                        <>
                        <button onClick={handleReassign} className="button reassign">
                            Reasignar staff
                        </button>

                        <button onClick={handleReturn} className="button return">
                            Devolver al staff
                        </button>

                        <button onClick={handleCloseModal} className="button close">
                            Cerrar
                        </button>
                    </>
                    ) : null}
                </Modal>
            )}

            {/* Modal para seleccionar el Staff */}
            {selectedActivity && (
                <Modal isOpen={isStaffModalOpen} onRequestClose={handleCloseStaffModal}>
                    <h1>Reasignar staff</h1>
                    <p><strong>Código de proyecto:</strong> {selectedActivity.codigo_proyecto}</p>
                    <p><strong>Razón social:</strong> {selectedActivity.razon_social}</p>
                    
                    <p>G: Numero Grupo | Actividades asignadas: ACT | Actividades iniciadas: INI | Horas trabajadas: HRS | Porcentaje de Efectividad: EF</p>

                    <select value={selectedActivity.staff_asignado || ''} onChange={handleStaffChange}>
                        <option value="">Seleccione staff</option>
                        {staffList.map((staff) => (
                            <option key={staff.nombre_asistente} value={staff.nombre_asistente}>
                                {`${staff.nombre_asistente} - G${staff.numero_grupo} ( ACT: ${staff.cantidad_actividad_asignadas}, INI: ${staff.actividades_iniciadas}, HRS: ${staff.horas_get}, EF: ${staff.effectiveness}%)`}
                            </option>
                        ))}
                    </select>
                    <>
                        <button onClick={handleAssignStaff} className="button assign">
                            Asignar nuevo staff
                        </button>

                        <button onClick={handleCloseStaffModal} className="button cancel">
                            Atrás
                        </button>
                    </>
                </Modal>
            )}
            <Toaster />
        </div>
    );
};

export default PausedActivitiesLider;
